export default __webpack_public_path__ + "static/media/Mark-Regular.v1.98873b42.woff";